export default {
    path: '/online',
    name: 'online',
    component: () => import('@/onlineInvite/main.vue'),
    redirect: '/onlineinvite/index',
    children: [
        {
            path: '/onlineinvite/index',
            name: 'onlineInvite',
            component: () => import('@/onlineInvite/index.vue'),
            meta: { showHeader: true, title: '活动规则' }
        }
    ],
}